import styled from '@emotion/styled';
import { Flex } from 'antd';

export const GalleryWrapper = styled.div`
  gap: 12px;
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;

  .image-mask {
    border-radius: 4px;
  }

  @media (max-width: 768px) {
    gap: 8px;
    padding-top: 12px;
  }
`;

export const ImageMaskWrapper = styled(Flex)`
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 4px;
`;

export const GalleryItemWrapper = styled.div`
  background: #ffffff;
  height: 160px;
  width: 90px;
  border-radius: 4px;
  border: 1px solid #f0f0f0;

  div.ant-image {
    height: 100%;
    width: 100%;
  }

  div.ant-skeleton {
    height: 100%;
    width: 100%;
  }

  @media (max-width: 768px) {
    height: 200px;
    width: calc(33.333% - 8px);
    max-width: 150px;
  }
`;

export const MobileImageWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const MobileDeleteButton = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #d9d9d9;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: rgba(255, 255, 255, 1);
    color: #333;
    border-color: #bfbfbf;
  }

  &:active {
    transform: scale(0.95);
  }
`;
